export default __webpack_public_path__ + "3e3efb042d81a70d3a9c0ce98d7f17c6.svg";